import { createContext } from "react";
import RESULTS_VIEW from "enums/RESULTS_VIEW";
import SPINNER_MODE from "enums/SPINNER_MODE";
import { ReactNode } from "react";
import ProjectDto from "types/ProjectDto";
import FilterGroupState from "../types/FilterGroupState";

export interface PanelManagementContextValues {
  canSearch: boolean;

  emailWithChangedRecruitingSource: string | undefined;
  setEmailWithChangedRecruitingSource: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;

  emailsFromSearchResult: string[];
  setEmailsFromSearchResult: React.Dispatch<React.SetStateAction<string[]>>;

  filterGroupStates: {
    [groupId: string]: FilterGroupState;
  };
  filterSyncGeneration: number;
  setFilterGroups: React.Dispatch<
    React.SetStateAction<{
      [groupId: string]: FilterGroupState;
    }>
  >;
  applyFilterGroups: (filterGroupStates: {
    [groupId: string]: FilterGroupState;
  }) => void;
  /** Applies a serialized filterString snapshot (parse + merge defaults + bump). Invalid JSON is a no-op. */
  applyFilterString: (filterString: string) => void;

  projectsById: { [projectId: string]: ProjectDto };

  profileToShow: string | undefined;
  setProfileToShow: React.Dispatch<React.SetStateAction<string | undefined>>;

  selectedScreeners: string[];
  setSelectedScreeners: React.Dispatch<React.SetStateAction<string[]>>;

  searchTriggered: boolean;
  setSearchTriggered: React.Dispatch<React.SetStateAction<boolean>>;

  showAllColumns: boolean;
  setShowAllColumns: React.Dispatch<React.SetStateAction<boolean>>;

  showFilters: boolean;
  setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;

  filterToSearchableOnly: boolean;
  setFilterToSearchableOnly: React.Dispatch<React.SetStateAction<boolean>>;

  resetContext: () => void;

  resultsView: RESULTS_VIEW;
  setResultsView: React.Dispatch<React.SetStateAction<RESULTS_VIEW>>;

  showSpinner: boolean;
  setShowSpinner: React.Dispatch<React.SetStateAction<boolean>>;
  spinnerMode: SPINNER_MODE;
  setSpinnerMode: React.Dispatch<React.SetStateAction<SPINNER_MODE>>;
  spinnerCaption: ReactNode;
  setSpinnerCaption: React.Dispatch<React.SetStateAction<ReactNode>>;
}

const PanelManagementContext = createContext<PanelManagementContextValues>({
  canSearch: false,

  emailWithChangedRecruitingSource: undefined,
  setEmailWithChangedRecruitingSource: () => undefined,

  emailsFromSearchResult: [],
  setEmailsFromSearchResult: () => [],

  filterGroupStates: {},
  filterSyncGeneration: 0,
  setFilterGroups: () => {},
  applyFilterGroups: () => {},
  applyFilterString: () => {},

  projectsById: {},

  profileToShow: undefined,
  setProfileToShow: () => {},

  selectedScreeners: [],
  setSelectedScreeners: () => {},

  searchTriggered: false,
  setSearchTriggered: () => {},

  showAllColumns: true,
  setShowAllColumns: () => {},

  showFilters: false,
  setShowFilters: () => {},

  filterToSearchableOnly: false,
  setFilterToSearchableOnly: () => {},

  resetContext: () => {},

  resultsView: RESULTS_VIEW.DATAGRID,
  setResultsView: () => {},

  showSpinner: false,
  setShowSpinner: () => {},
  spinnerMode: SPINNER_MODE.DEFAULT,
  setSpinnerMode: () => {},
  spinnerCaption: undefined,
  setSpinnerCaption: () => {},
});
PanelManagementContext.displayName = "PanelManagementContext";

export default PanelManagementContext;
